<template>
  <div>
    <!-- Section de chargement -->
    <div v-if="loadnotification  == false" class="w-full h-[3.8rem] px-1">
      <div v-for="i in 20" :key="i" class="w-full h-full flex">
        <div class="w-[28%] h-full flex items-center">
          <div class="w-[3.3rem] h-[3.3rem] mx-auto bg-gray-300 animate-pulse rounded-full"></div>
        </div>
        <div class="w-[78%] h-full py-1 px-1 space-x-1">
          <div class="w-full h-[90%] space-y-1">
            <div class="w-full h-1 bg-gray-300 animate-pulse"></div>
            <div class="w-full h-1 bg-gray-300 animate-pulse"></div>
            <div class="w-full h-1 bg-gray-300 animate-pulse"></div>
            <div class="w-full h-1 bg-gray-300 animate-pulse"></div>
            <div class="w-full h-1 bg-gray-300 animate-pulse"></div>
          </div>
          <div class="w-full h-[10%] flex">
            <div class="w-6 h-1 absolute right-1 bg-gray-300 animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section des notifications -->
    <div id="scrollNotification" v-if="loadnotification" @scroll="loadInfinite" class="w-full max-h-[18rem] overflow-y-auto scrollbar-hide">
      <div class="w-full flex text-gray-500 h-[3.8rem] items-center" v-if="notifications.length === 0">
        <p class="mx-auto text-xs">{{ $t('aucunenotification') }}</p>
      </div>
      <div>
        <div v-for="(notification, index) in notifications" :key="notification.id" :class="notification[0].read_at ? 'bg-gray-100' : 'bg-[#FF9900] bg-opacity-[0.3]'" class="w-full flex-initial space-y-1 px-1" @click="openNotification(notification)">
          <div :class="parsedData(notification).type ? 'cursor-pointer' : ''" class="space-x-2 flex w-full">
            <div class="h-auto flex items-center">
              <div v-if="!parsedData(notification).avatar" class="bg-black w-[3rem] h-[3rem] rounded-full overflow-hidden p-2">
                <img class="w-full h-full mx-auto object-cover object-center" src="/logo/mel_logo_blanc.png" alt="">
              </div>
              <div v-else class="bg-black w-[3rem] h-[3rem] rounded-full overflow-hidden">
                <img class="w-full h-full object-cover object-center rounded-full" :src="parsedData(notification).avatar" alt="">
              </div>
            </div>
            <div class="h-auto py-2 pr-1">
              <div class="h-[90%] space-y-1 flex items-center">
                <p :id="index" class="text-[0.7rem] text-justify hyphens-auto">{{ convertTextInGras(parsedData(notification)['titre' + langue], index) }}</p>
              </div>
              <div class="h-[10%] flex justify-end">
                <p class="text-[0.6rem] text-gray-500">{{ notification[1][langue.toLowerCase()] }}</p>
              </div>
            </div>
          </div>
          <hr class="w-full border-gray-300"/>
        </div>
      </div>
      <div v-if="!fin && scrollExec" class="w-full flex items-center py-2">
        <div class="chaotic-orbit mx-auto"></div>
      </div>
      <div class="w-full text-center text-xs text-gray-500" v-if="fin && notifications.length > 0">
        <p v-if="langue === 'Fr'">Plus aucune notifications !</p>
        <p v-if="langue === 'En'">No more notifications !</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['notificationsnonlu'],
  data() {
    return {
      notifications: [],
      loadnotification: false,
      langue: '',
      page: 1,
      fin: false,
      scrollExec: false,
      nbreNotificationsNonLu: this.notificationsnonlu
    };
  },
  unmounted() {
    // Émettre un événement pour recharger le nombre de notifications non lues à 0
    window.emitter.emit("reloadNumberNotificationNonLu", 0);
  },
  mounted() {
    // Initialiser la langue
    this.langue = localStorage.getItem('langue')[0].toUpperCase() + localStorage.getItem('langue').slice(1);
    // Charger les notifications depuis le store ou depuis l'API
    if (this.$store.state.notifications.length > 0) {
      this.notifications = this.$store.state.notifications;
      this.loadnotification = true;
      this.page = Math.ceil(this.$store.state.notifications.length / 10) + 1;
      if (this.nbreNotificationsNonLu > 0) this.readNotification();
    } else {
      this.loadNotifications();
    }

    // Restaurer la position de défilement
    this.$nextTick(() => {
      const scrollNotification = document.getElementById('scrollNotification');
      if (scrollNotification) {
        scrollNotification.scrollTop = this.$store.state.routerLastPosition['scrollNotification'];
      }
    });
  },
  methods: {
    // Méthode pour parser les données de notification
    parsedData(notification) {
      return JSON.parse(notification[0]['data']);
    },
    // Méthode pour convertir certains textes en gras
    async convertTextInGras(titre, index) {
      const regex = /<.+?>/g;
      const resultats = titre.match(regex);
      if (resultats && resultats.length > 0) {
        for (const resultat of resultats) {
          const re = new RegExp(`${resultat}`, 'g');
          titre = titre.replace(re, `<span class="font-bold text-xs">${resultat.slice(1, resultat.length - 1)}</span>`);
        }
        this.$nextTick(() => {
          document.getElementById(`${index}`).innerHTML = titre;
        });
      }
      return titre.trim();
    },
    // Méthode pour marquer les notifications comme lues
    readNotification() {
      this.axios.post(this.requestHttp + 'readnotification', '', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).catch(() => {});
    },
    // Méthode pour ouvrir une notification en fonction de son type
    openNotification(notification) {
      const data = this.parsedData(notification);
      if (data.type === 'user') {
        this.$router.push({ name: 'viewprofil', query: { id: this.$crypto(data.id), name: data.name } });
        window.emitter.emit("reloadProfil", this.$crypto(data.id));
      } else if (data.type === 'coupon') {
        this.$router.push('mes-coupons');
      } else if (data.type === 'article') {
        this.$store.dispatch('requestSelectArticleDetailPage', {});
        this.$router.push({ name: 'details', query: { id: this.$crypto(data.id), prix: data.prix, nom: data.name, marque: data.marque, ville: data.ville, image: this.$crypto(data.image) } });
        window.emitter.emit("reloadDetailPage", this.$crypto(data.id));
      }
    },
    // Méthode pour charger les notifications depuis l'API
    loadNotifications() {
      this.axios.get(this.requestHttp + 'notifications?page=' + this.page, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.notifications = data[0];
        this.$store.state.notifications = data[0];
        this.loadnotification = true;
        this.page += 1;
        if (this.nbreNotificationsNonLu > 0) this.readNotification();
      }).catch(() => {});
    },
    // Méthode pour gérer le défilement infini
    infiniteHandler() {
      this.axios.get(this.requestHttp + 'notifications?page=' + this.page, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        if (data[0].length > 0) {
          this.notifications.push(...data[0]);
          this.page += 1;
          this.scrollExec = false;
        } else {
          this.fin = true;
        }
      }).catch(() => {});
    },
    // Méthode pour charger plus de notifications lors du défilement
    loadInfinite(e) {
      const max = e.target.scrollHeight;
      const base = e.target.clientHeight;
      const scrollY = e.target.scrollTop;
      const delta = max - (base + scrollY);
      this.$store.dispatch('requestRouterLastPosition', { name: 'scrollNotification', scrollPosition: e.target.scrollTop });
      if (delta <= max * 0.4 && !this.scrollExec) {
        if (this.notifications.length) {
          this.scrollExec = true;
          this.infiniteHandler();
        }
      }
    },
  },
  computed: {
    // URL de l'API
    requestHttp() {
      return this.$store.state.api;
    },
    // URL des fichiers
    requestFile() {
      return this.$store.state.apifile;
    },
  }
}
</script>

<style>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>